import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
} from "@angular/forms";

/**
 * Custom validator for password strength
 * Requires: min 8 chars, uppercase, lowercase, number, special character
 */
export function passwordStrengthValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value as string;
  if (!value) return null;

  const errors: ValidationErrors = {};

  if (value.length < 8) {
    errors["minLength"] = true;
  }
  if (!/[A-Z]/.test(value)) {
    errors["uppercase"] = true;
  }
  if (!/[a-z]/.test(value)) {
    errors["lowercase"] = true;
  }
  if (!/[0-9]/.test(value)) {
    errors["number"] = true;
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value)) {
    errors["specialChar"] = true;
  }

  return Object.keys(errors).length ? errors : null;
}

/**
 * Custom validator to check if passwords match
 */
export function passwordMatchValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const formGroup = control as FormGroup;
  const newPassword = formGroup.get("newPassword")?.value as string;
  const confirmPassword = formGroup.get("confirmPassword")?.value as string;

  if (newPassword && confirmPassword && newPassword !== confirmPassword) {
    return { passwordMismatch: true };
  }
  return null;
}
